export enum CTA_TEXT {
  GET_STARTED = 'Get started',
  BUILD_BOX = 'Build your box',
}
